export const schemaPelanggaran = {
    tgl: {
        presence: { allowEmpty: false, message: 'harus diisi' },
    },
    pelanggaran: {
        presence: { allowEmpty: false, message: 'harus dipilih' },
    },
}